import { render, staticRenderFns } from "./authentications.vue?vue&type=template&id=8ff34320&scoped=true"
import script from "./authentications.vue?vue&type=script&lang=js"
export * from "./authentications.vue?vue&type=script&lang=js"
import style0 from "./authentications.vue?vue&type=style&index=0&id=8ff34320&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ff34320",
  null
  
)

export default component.exports